if (!customElements.get('m-slideshow')) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderContainer = null;
      this.autoplay = false;
      this.autoplaySpeed = 5;
      this.showArrows = false;
      this.showDots = false;
      this.lastVideo = null;
      this.lastActive = null;
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5;
      this.showArrows = this.dataset.enableArrows === 'true';
      this.showDots = this.dataset.enableDots === 'true';
      this.loop = this.dataset.loop !== 'false';
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector('.swiper-container');
      this.initSlider();
      document.addEventListener('shopify:block:select', (e) => this.onBlockSelect(e));
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? { delay: this.autoplaySpeed * 1000, disableOnInteraction: true }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: this.loop,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector('.m-slider-controls__button-next'),
              prevEl: this.querySelector('.m-slider-controls__button-prev'),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector('.swiper-pagination'),
              clickable: true,
              bulletClass: 'm-dot',
              bulletActiveClass: 'm-dot--active',
            }
          : false,
        breakpoints: {
          992: { threshold: 2 },
        },
      });

      if (this.slider) {
        this.slider.on('init', (swiper) => this.handleChange(swiper));
        this.slider.on('slideChange', (swiper) => this.handleChange(swiper));
        this.slider.init();
      }
    }

    handleChange(swiper) {
      if (this.lastActive !== null && this.lastActive !== undefined) {
        if (this.loop) {
          swiper.slideToLoop(this.lastActive);
        } else {
          swiper.slideTo(this.lastActive);
        }
        this.lastActive = null;
        return;
      }

      const { activeIndex, slides } = swiper;
      const activeSlide = slides?.[activeIndex];
      const slideType = activeSlide?.dataset?.slideType;

      if (this.lastVideo && !(activeSlide?.querySelector('video') === this.lastVideo)) {
        try {
          this.lastVideo.pause();
        } catch (e) {}
        this.lastVideo = null;
      }

      if (slideType !== 'video_slide') return;

      const video = activeSlide?.querySelector('video[data-slide-video], video');
      if (!video || this.lastVideo === video) return;

      try {
        video.load();
      } catch (e) {}
      video.muted = true;
      video.playsInline = true;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => {
            this.lastVideo = video;
          })
          .catch(() => {
            this.lastVideo = video;
          });
      } else {
        this.lastVideo = video;
      }
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block?.dataset?.slide);
      if (Number.isNaN(index)) return;

      this.lastActive = index;
      if (!this.slider) return;

      if (this.loop) {
        this.slider.slideToLoop(index);
      } else {
        this.slider.slideTo(index);
      }
    }
  }

  customElements.define('m-slideshow', MSlideshow);
}
